import { SHORTCUTS, SECTIONS } from "../input/shortcuts";

let openEl: HTMLElement | null = null;

export function toggleShortcuts() {
  if (openEl) {
    openEl.remove();
    openEl = null;
    return;
  }
  const backdrop = document.createElement("div");
  backdrop.className = "modal-backdrop";
  let body = "";
  for (const section of SECTIONS) {
    const items = SHORTCUTS.filter((s) => s.section === section);
    if (!items.length) continue;
    body += `<div class="sc-section-title">${section}</div>`;
    for (const s of items) {
      const keys = s.keys.map((k) => `<kbd>${k}</kbd>`).join("");
      body += `<div class="sc-row"><span class="sc-label">${s.desc}</span><span class="kbd">${keys}</span></div>`;
    }
  }
  backdrop.innerHTML = `
    <div class="modal" style="min-width:560px;max-width:720px">
      <div class="modal-head"><span>Keyboard shortcuts</span><button class="modal-close">×</button></div>
      <div class="modal-body"><div class="sc-grid-wrap">${body}</div></div>
    </div>`;
  document.body.appendChild(backdrop);
  const close = () => {
    backdrop.remove();
    openEl = null;
  };
  backdrop.querySelector(".modal-close")!.addEventListener("click", close);
  backdrop.addEventListener("click", (e) => {
    if (e.target === backdrop) close();
  });
  openEl = backdrop;
}
